import { render, staticRenderFns } from "./MainLedgerCard3Selection.vue?vue&type=template&id=43151ace"
import script from "./MainLedgerCard3Selection.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard3Selection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports